import { __decorate, __metadata } from "tslib";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { EngagementActivityModel, IEngagementActivity } from "@/store/models/engagements/engagementActivity";
import EngagementsModule from "@/store/modules/engagements.module";
import BaseMixer from "../../BaseMixer";
import { toaster } from "@/utilities/toaster";
import StageActivityDocs from "./StageActivityDocs.vue";
import StageActivityActions from "./StageActivityActions.vue";
import StageActivityNotes from "./StageActivityNotes.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
let StageActivity = /** @class */ (() => {
    var _a;
    let StageActivity = class StageActivity extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.selectedActivityId = null;
            this.isEditNotes = false;
            this.showRemoveActivity = false;
            this.currentActivityFace = "ActivityNotes";
            this.showEditTenantEngagementActivityModal = false;
            this.editTenantEngagementStageActivity = new EngagementActivityModel();
        }
        openEditActivityModal() {
            this.editTenantEngagementStageActivity = new EngagementActivityModel();
            this.editTenantEngagementStageActivity = {
                activityId: this.activity.activityId,
                activityDesc: this.activity.activityDesc,
                baseline: this.activity.baseline,
                threshold: this.activity.threshold,
                actuals: this.activity.actuals,
                isTenantVisible: this.activity.isTenantVisible,
                notes: this.activity.notes,
                docs: this.activity.docs,
                actions: this.activity.actions,
            };
            this.showEditTenantEngagementActivityModal = true;
        }
        closeEditActivityModal() {
            this.showEditTenantEngagementActivityModal = false;
        }
        saveTenantEngagementActivity() {
            this.validate("editTenantEngagementStageActivtyObserver").then((response) => {
                if (response) {
                    var stage = EngagementsModule.model.stages.find((x) => x.activities.find((x) => x.activityId == this.editTenantEngagementStageActivity.activityId));
                    EngagementsModule.SaveTenantEngagementActivity([EngagementsModule.model.id, stage.stageId, this.editTenantEngagementStageActivity]).then((response) => {
                        this.closeEditActivityModal();
                        toaster.ShowApiSuccess(response);
                    });
                }
            });
        }
        removeActivity(activityId) {
            this.activityId = activityId;
            this.showRemoveActivity = true;
        }
        removingActivity() {
            EngagementsModule.DeleteTenantEnagagementActivity(this.activityId).then((response) => {
                this.showRemoveActivity = false;
                toaster.ShowApiSuccess(response);
            });
        }
        markTenantEnagagementActivity(activity) {
            EngagementsModule.MarkTenantEnagagementActivity(activity).then((response) => {
                toaster.ShowApiSuccess(response);
            });
        }
        //public inCompleteActivity(activity: IEngagementActivity): void {
        //    EngagementsModule.MarkTenantEnagagementActivity(activity).then(response => {
        //        toaster.ShowApiSuccess(<IServiceResponse>response);
        //    });
        //}
        closeActvityModal(modalName) {
            var that = this;
            that.$root.$emit("bv::hide::modal", modalName);
        }
        resetNote() {
            this.isEditNotes = false;
        }
        get getFaceComponent() {
            if (this.currentActivityFace === "ActivityNotes") {
                return "StageActivityNotes";
            }
            else if (this.currentActivityFace === "ActivityDocs") {
                return "StageActivityDocs";
            }
            else if (this.currentActivityFace === "ActivityActions") {
                return "StageActivityActions";
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IEngagementActivity !== "undefined" && IEngagementActivity) === "function" ? _a : Object)
    ], StageActivity.prototype, "activity", void 0);
    StageActivity = __decorate([
        Component({
            components: {
                StageActivityDocs,
                StageActivityActions,
                StageActivityNotes,
                DeleteComponent,
            },
        })
    ], StageActivity);
    return StageActivity;
})();
export default StageActivity;
